import { render, staticRenderFns } from "./CreateTaskForm.vue?vue&type=template&id=52e06a97&scoped=true&"
import script from "./CreateTaskForm.vue?vue&type=script&lang=ts&"
export * from "./CreateTaskForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreateTaskForm.vue?vue&type=style&index=0&id=52e06a97&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e06a97",
  null
  
)

export default component.exports